module.exports = __webpack_public_path__ + "static/media/Vulpix_gaussian2.2bca22ef.png";